import { Checkbox, CheckboxProps } from '@chakra-ui/react';
import React from 'react';

interface KCheckboxProps extends CheckboxProps {
  children?: React.ReactNode; // Make children optional
}

export const KCheckbox: React.FC<KCheckboxProps> = ({ children, ...props }) => {
  return <Checkbox {...props}>{children}</Checkbox>;
};
